// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3cC6i","title":"ClientInsurance_title__11oU_","itemText":"ClientInsurance_itemText__gSoch"};